import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Layout from "../components/layouts/Layout";

type Props = {
  children: React.ReactNode;
  redirectLink?: string;
  title?: string;
  headline?: string;
};

function ProtectedRouteCustomer({ children, redirectLink, title = "Customer", headline = "" }: Props) {
  const customerToken = useSelector(
    (state: RootState) => state.customer.accessToken
  );
  const location = useLocation();

  const currentPath = encodeURIComponent(location.pathname + location.search);

  if (!customerToken) {
    return (
      <Navigate
        to={redirectLink ? redirectLink : `/customer/sendOtp?redirect=${currentPath}`}
        replace
      />
    );
  }

  return (
    <Layout title={title} headline={headline}>
      {children}
    </Layout>
  );
}

export default ProtectedRouteCustomer;
